import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import { colores, estilosTextosPrincipales } from "AppStyle";

export default makeStyles({
    classGrid: {
        textAlign: 'left',
        marginTop: '15px',
        marginBottom: '19px',
        marginRight: '32px',
        width: 'auto',
        display: 'block'
    },
    classInputLabel: {
        ...estilosTextosPrincipales.body2,
        color: colores.escalaGrises.ochenta,
        fontSize: '15spx',
        fontWeight: 'bold',
        letterSpacing: '0',
        lineHeight: ' 17px',
        marginBottom: '5px',
        position: 'relative',
        '&.Mui-focused': {
            color: '#555555',
        },
    },
    classSelect: {
        ...estilosTextosPrincipales.body2,
        fontSize: '14px',
        letterSpacing: '0px',
        boxSizing: 'border-box',
        height: '48px',
        width: '328px',
        borderRadius: '4px',
        paddingLeft: '12px',
        color: colores.escalaGrises.cien,
        border: `1px solid ${colores.principales.apoyo}`,
        '&:hover': {
            border: `2px solid ${colores.principales.principal}`     },
        '&:focused': {
            border: `2px solid ${colores.principales.principal}`
        }
    },
    classMenuItem: {
        boxSizing: 'border-box',
        height: '48px',
        width: '328px',
        paddingTop: '11px',
        paddingBottom: '13px',
        paddingLeft: '12px',
        color: colores.escalaGrises.ochenta,
        ...estilosTextosPrincipales.body2,
        fontSize: '12px'
    }
});

export const overrideStyle = createMuiTheme({
    overrides: {
        MuiMenuItem: {
            root: {
                ...estilosTextosPrincipales.body2,
                fontSize: '14px'
            }
        },
        MuiListItem: {
            root: {
                color: colores.escalaGrises.ochenta,
                '&$selected': {
                    backgroundColor: colores.principales.apoyo
                },
                '&:hover': {
                    backgroundColor: colores.principales.apoyo
                }
            }
        },
        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'transparent'
                }
            },
            icon: {
                color: colores.escalaGrises.cien,
                marginRight: '5px',
                '&:hover': {
                    color: 'rgba(0, 0, 0, 0.04)'
                }
            }
        },
        MuiPaper: {
            root: {
                width: 'auto%',
                height: 'fit-content'
            },
            elevation8: {
                boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 1px 1px 1px rgba(0,0,0,0.14),0px 1px 1px 1px rgba(0,0,0,0.12)'
            }
        },
        MuiPopover: {
            paper: {
                marginTop: '12px',
                marginLeft: '-6px',
                width: '328px'
            }
        }
    }
});